__turbopack_context__.v({
  "className": "fraunces_867fe227-module__rfT_IW__className",
});
